import { tv } from 'tailwind-variants';

const styles = tv({
    base: "iris:grid",
    variants: {
        xsCols: {
            1: "iris:grid-cols-1",
            2: "iris:grid-cols-2",
            3: "iris:grid-cols-3",
            4: "iris:grid-cols-4",
            6: "iris:grid-cols-6",
            12: "iris:grid-cols-12",
        },
        smCols: {
            1: "iris:sm:grid-cols-1",
            2: "iris:sm:grid-cols-2",
            3: "iris:sm:grid-cols-3",
            4: "iris:sm:grid-cols-4",
            6: "iris:sm:grid-cols-6",
            12: "iris:sm:grid-cols-12",
        },
        mdCols: {
            1: "iris:md:grid-cols-1",
            2: "iris:md:grid-cols-2",
            3: "iris:md:grid-cols-3",
            4: "iris:md:grid-cols-4",
            6: "iris:md:grid-cols-6",
            12: "iris:md:grid-cols-12",
        },
        lgCols: {
            1: "iris:lg:grid-cols-1",
            2: "iris:lg:grid-cols-2",
            3: "iris:lg:grid-cols-3",
            4: "iris:lg:grid-cols-4",
            6: "iris:lg:grid-cols-6",
            12: "iris:lg:grid-cols-12",
        },
        xsRows: {
            1: "iris:grid-rows-1",
            2: "iris:grid-rows-2",
            3: "iris:grid-rows-3",
            4: "iris:grid-rows-4",
            6: "iris:grid-rows-6",
        },
        smRows: {
            1: "iris:sm:grid-rows-1",
            2: "iris:sm:grid-rows-2",
            3: "iris:sm:grid-rows-3",
            4: "iris:sm:grid-rows-4",
            6: "iris:sm:grid-rows-6",
        },
        mdRows: {
            1: "iris:md:grid-rows-1",
            2: "iris:md:grid-rows-2",
            3: "iris:md:grid-rows-3",
            4: "iris:md:grid-rows-4",
            6: "iris:md:grid-rows-6",
        },
        lgRows: {
            1: "iris:lg:grid-rows-1",
            2: "iris:lg:grid-rows-2",
            3: "iris:lg:grid-rows-3",
            4: "iris:lg:grid-rows-4",
            6: "iris:lg:grid-rows-6",
        },
        xsGap: {
            0: "iris:gap-(--base-space-px-0)",
            1: "iris:gap-(--base-space-px-1)",
            2: "iris:gap-(--base-space-px-2)",
            4: "iris:gap-(--base-space-px-4)",
            8: "iris:gap-(--base-space-px-8)",
        },
        smGap: {
            0: "iris:sm:gap-(--base-space-px-0)",
            1: "iris:sm:gap-(--base-space-px-1)",
            2: "iris:sm:gap-(--base-space-px-2)",
            4: "iris:sm:gap-(--base-space-px-4)",
            8: "iris:sm:gap-(--base-space-px-8)",
        },
        mdGap: {
            0: "iris:md:gap-(--base-space-px-0)",
            1: "iris:md:gap-(--base-space-px-1)",
            2: "iris:md:gap-(--base-space-px-2)",
            4: "iris:md:gap-(--base-space-px-4)",
            8: "iris:md:gap-(--base-space-px-8)",
        },
        lgGap: {
            0: "iris:lg:gap-(--base-space-px-0)",
            1: "iris:lg:gap-(--base-space-px-1)",
            2: "iris:lg:gap-(--base-space-px-2)",
            4: "iris:lg:gap-(--base-space-px-4)",
            8: "iris:lg:gap-(--base-space-px-8)",
        },
    },
    defaultVariants: {
        xsColumns: 12,
        xsGap: 4,
        xsRows: 1,
    },
});

export { styles as default };
